import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import TeacherSetup from "TeacherSetup";
import StudentSetup from "StudentSetup";
import ManageFamily from "Course/routes/ManageFamily";

export default store => ({
  path: "user-directory",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "organizational-structure" */ "./components/UserDirectory"
      ),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "SchoolSetup/modules/SchoolSetupModule"
      ),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "ResetInviteAndSignInCodeModal/modules/ResetInviteAndSignInCodeModalModule"
      ),
    ]).then(([importedModule0, importedModule1, importedModule2]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      const resetInviteAndSignInCodeModalModule = importedModule2.default;

      injectReducer(store, {
        key: "schoolSetup",
        reducer,
      });

      injectReducer(store, {
        key: "resetInviteAndSignInCodeModal",
        reducer: resetInviteAndSignInCodeModalModule,
      });

      return component;
    })
  ),
  childRoutes: [TeacherSetup(store), StudentSetup(store), ManageFamily(store)],
});
